import * as Yup from 'yup';

const campaignName = Yup.string()
  .trim()
  .min(1, 'Campaign name needs to have 1 character or more')
  .required('Campaign name is required llll');

export default campaignName;
